import React, { useState, useEffect } from "react"

import { navigate } from "gatsby"

import { Link } from "gatsby"
import { observer, inject } from "mobx-react"

import { Wrapper } from "../components/base/wrapper/wrapper"
import { SEO } from "../components/base/seo/seo"
import { RegionToggle } from "../components/modules/region-toggle/region-toggle"

import { isBrowser } from "../helpers/helpers"

const ManageCookies = inject("regionStore")(
  observer((props) => {
    const { regionStore } = props;

    const getCookie = (cname) => {
      let name = cname + "=";
      let ca = document.cookie.split(';');
      for(let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    }
  
    const setRootCookie = (cname, cvalue, exdays) => {
      const d = new Date();
      d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
      let expires = "expires="+d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";domain=.businessdebtline.org;path=/";
    }

    const saveCookieSettings = e => {
      e.preventDefault()

      window.dataLayer = window.dataLayer || [];
      function gtag() { window.dataLayer.push(arguments); }
      
      setRootCookie('cookie_preferences', 1, 365)

      var analyticsConsentStatus;
      var advertisingConsentStatus;

      if(analyticsCookies === '1') {
          setRootCookie('allow_analytics_cookies', 1, 365);
          analyticsConsentStatus = 'granted';
      } else {
          setRootCookie('allow_analytics_cookies', 0, 365);
          analyticsConsentStatus = 'denied';
      }

      if(advertisingCookies === '1') {
          setRootCookie('allow_advertising_cookies', 1, 365);
          advertisingConsentStatus = 'granted';
      } else {
          setRootCookie('allow_advertising_cookies', 0, 365);
          advertisingConsentStatus = 'denied';
      }

      gtag('consent', 'update', {
          'ad_personalization': advertisingConsentStatus,
          'ad_storage': advertisingConsentStatus,
          'ad_user_data': advertisingConsentStatus,
          'analytics_storage': analyticsConsentStatus
      });

      gtag('event', 'consent_update', {
          'event_category': 'consent',
          'event_label': 'updated',
          'value': 1
      });

      const returnToPage = getCookie('return_to_page')
      if(returnToPage != '') {
        navigate(returnToPage)
      }
    }

    const [analyticsCookies, setAnalyticsCookies] = useState('1');
    const [advertisingCookies, setAdvertisingCookies] = useState('1');

    const handleAnalyticsCookiesChange = (e) => {
      setAnalyticsCookies(e.target.value);
    }

    const handleAdvertisingCookiesChange = (e) => {
      setAdvertisingCookies(e.target.value);
    }

    const handleOnNoSubmit = e => {
      e.preventDefault()
    }

    return (
      <Wrapper>
        <SEO title="Manage cookies" description="Manage cookies" />
        <div className="row">
          <div className="offset-2 col-8">
            <h1 className="mb-3">Manage cookies</h1>
            <form id="manageCookieSettings" onSubmit={handleOnNoSubmit}>
              <h2>Your privacy</h2>
              <p>When you visit any website, it may store or retrieve information on your browser, mostly in the form of cookies. This information might be about you, your preferences or your device and is mostly used to make the site work as you expect it to. The information does not usually directly identify you, but it can give you a more personalized web experience. You can choose not to allow some types of cookies. Click on the different category headings to find out more and change our default settings. However, blocking some types of cookies may impact your experience of the site and the services we are able to offer.</p>            
              <h2>Essential cookies</h2>
              <div class="radio-button">
                <label><input type="radio" checked="checked" /> Active</label>
              </div>
              <p>These cookies are necessary for the website to function and cannot be switched off in our systems. They are usually only set in response to actions made by you which amount to a request for services, such as setting your privacy preferences, logging in or filling in forms. You can set your browser to block or alert you about these cookies, but some parts of the site will not then work. These cookies do not store any personally identifiable information.</p>
              <h2>Analytics cookies</h2>
              <div class="radio-button">
                <label><input id="analytics_cookies_active" name="analytics_cookies" type="radio" value="1" onChange={handleAnalyticsCookiesChange} checked={analyticsCookies === '1'} /> Active</label>
              </div>
              <div class="radio-button">
                <label><input id="analytics_cookies_inactive" name="analytics_cookies" type="radio" value="0" onChange={handleAnalyticsCookiesChange} checked={analyticsCookies === '0'} /> Inactive</label>
              </div>
              <p>These cookies allow us to count visits and traffic sources so we can measure and improve the performance of our site. They help us to know which pages are the most and least popular and see how visitors move around the site. All information these cookies collect is aggregated and therefore anonymous. If you do not allow these cookies we will not know when you have visited our site, and will not be able to monitor its performance.</p>
              <h2>Advertising cookies</h2>
              <div class="radio-button">
                <label><input id="advertising_cookies_active" name="advertising_cookies" type="radio" value="1" onChange={handleAdvertisingCookiesChange} checked={advertisingCookies == 1} /> Active</label>
              </div>
              <div class="radio-button">
                <label><input id="advertising_cookies_inactive" name="advertising_cookies" type="radio" value="0" onChange={handleAdvertisingCookiesChange} checked={advertisingCookies == 0} /> Inactive</label>
              </div>
              <p>These cookies may be set through our site by our advertising partners and used by us to measure our marketing activity. They may be used by those companies to build a profile of your interests and show you relevant adverts on other sites, including on social media websites. They do not store your contact details, but are based on uniquely identifying your browser and internet enabled device.</p>
              <input id="saveCookieSettings" type="submit" value="Save cookie settings" onClick={saveCookieSettings} class="btn btn-primary text-white" />
            </form>          
          </div>
        </div>
      </Wrapper>
    )
  })
)

export default ManageCookies
